import React from "react";
import Icon from "../../../components/AppIcon";

const CallToActionSection = ({ onStartCalculator }) => {
  const features = [
    {
      id: 1,
      label: "Professional PDF export capabilities",
      icon: "FileDown",
      description: "Share results in professional format",
    },
    {
      id: 2,
      label: "Mobile-friendly responsive design",
      icon: "Smartphone",
      description: "Calculate anywhere, any device",
    },
  ];

  return (
    <section className="w-full">
      <div className="bg-gradient-to-br from-primary-50 via-surface to-accent-50/10 rounded-none md:rounded-3xl border-0 md:border md:border-border/40 shadow-none md:shadow-elevation-1 p-6 md:p-12 backdrop-blur-sm min-h-screen md:min-h-0 flex flex-col justify-center">
        <div className="max-w-3xl mx-auto w-full">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading-semibold text-text-primary mb-6 md:mb-8 leading-tight text-center">
            Ready to Optimize Your Textile Processing Costs?
          </h2>

          <p className="text-base md:text-lg text-text-secondary mb-8 md:mb-12 max-w-2xl mx-auto text-center">
            Join thousands of textile professionals who trust TextileCalc Pro
            for accurate cost analysis and strategic decision-making.
          </p>

          {/* CTA Button Section - Moved above feature cards */}
          <div className="flex flex-col items-center space-y-4 mb-8 md:mb-12">
            <button
              onClick={onStartCalculator}
              className="group bg-primary hover:bg-primary-600 text-white px-12 py-4 rounded-xl text-xl font-body-medium transition-all duration-300 shadow-elevation-2 inline-flex items-center space-x-4 hover:scale-[1.02] active:scale-[0.98]"
            >
              <Icon
                name="Rocket"
                size={24}
                className="text-primary-100 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
              />
              <span className="hidden md:inline">
                Start Your Calculation Now
              </span>
              <span className="md:hidden">Start Now</span>
              <Icon
                name="ArrowRight"
                size={20}
                className="text-primary-100 transition-all duration-300 group-hover:translate-x-1.5 group-hover:opacity-90"
              />
            </button>

            <div className="bg-success-50/80 px-4 py-1.5 rounded-full border border-success/10">
              <div className="flex items-center justify-center space-x-2">
                <Icon name="Clock" size={16} className="text-success" />
                <span className="text-sm font-body-medium text-success">
                  Quick 5-min Setup
                </span>
              </div>
            </div>
          </div>

          {/* Feature List */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 mb-8 md:mb-12">
            {features.map((feature) => (
              <div
                key={feature.id}
                className={`group relative border border-border/40 backdrop-blur-sm rounded-xl md:rounded-2xl p-4 md:p-6 transition-all duration-300 hover:border-primary/30 hover:shadow-lg hover:-translate-y-1 ${
                  feature.id === 1
                    ? "bg-gradient-to-br from-accent-50/30 to-transparent"
                    : "bg-gradient-to-br from-secondary-100/30 to-transparent"
                }`}
              >
                <div className="flex items-start space-x-3 md:space-x-4">
                  <div
                    className={`w-10 h-10 md:w-12 md:h-12 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0 transition-all duration-300 group-hover:scale-110 group-hover:rotate-3 ${
                      feature.id === 1
                        ? "bg-accent-100 group-hover:bg-accent-100"
                        : "bg-primary-100/80 group-hover:bg-primary-100/80"
                    }`}
                  >
                    <Icon
                      name={feature.icon}
                      size={18}
                      className={`md:w-5 md:h-5 transition-transform duration-300 group-hover:scale-110 ${
                        feature.id === 1 ? "text-accent" : "text-primary-600"
                      }`}
                    />
                  </div>
                  <div>
                    <span className="block font-body-medium text-text-primary mb-1 md:mb-2 text-sm md:text-base">
                      {feature.label}
                    </span>
                    <span className="text-xs md:text-sm text-text-secondary block">
                      {feature.description}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
